import FAUCET_ABI from './faucet.json'

const FAUCET_ADDRESS = '0x5546e0295c7bb85b2fC00883B6025BA0Db06e50A'

export { FAUCET_ADDRESS, FAUCET_ABI }
